var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.options)?[_vm._v(_vm._s(_vm.findValue()))]:[_c('vk-spinner')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }